import React from 'react'
import GenericCancelController from './GenericCancelController'
import { Appointment, Requisition } from 'models'
import { useFetchList } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from '../Dialog.module.sass'

const requisitionsExistsInProcessRequisitions = (
	appointmentRequisitions,
	processRequisitions
) => {
	if (!appointmentRequisitions?.length) return []

	return appointmentRequisitions.map(({ id }) => ({
		id: id,
		existsInProcess:
			processRequisitions?.findIndex((elem) => id === elem.id) >= 0,
	}))
}

const renderRequisitionsLinks = (
	requisitionsInProcess,
	gotoRequisition,
	processId
) => {
	return requisitionsInProcess.length ? (
		<span>
			(
			{requisitionsInProcess?.map(
				({ id: requisitionId, existsInProcess }, key) => {
					return existsInProcess ? (
						<small
							key={key}
							className={styles['link']}
							onClick={() =>
								gotoRequisition(processId, requisitionId)
							}
						>
							#{requisitionId}
						</small>
					) : (
						<small key={key}>#{requisitionId}</small>
					)
				}
			)}
			)
		</span>
	) : (
		<></>
	)
}

const CancelAppointmentController = (props) => {
	const { data, dismiss, id } = props
	const { i18n, gotoRequisition } = useGlobal()

	const processRequisitionsUri = `/clinical_processes/${data.processId}/requisitions`
	const appointmentUri = `clinical_processes/${data.processId}/appointments/${data.processRequest?.appointmentId}`
	const appointmentRequisitionsUri = `clinical_processes/${data.processId}/appointment/${data.processRequest?.appointmentId}/requisitions`

	const {
		contents: [appointment, processRequisitions, appointmentRequisitions],
	} = useFetchList(
		[appointmentUri, processRequisitionsUri, appointmentRequisitionsUri],
		[Appointment.fromJSON, Requisition.fromJSON, Requisition.fromJSON]
	)

	const filteredAppointmentRequisitions = (
		appointmentRequisitions || []
	).filter((elem) => {
		return parseInt(elem.id, 10) !== appointment.requisitionId
	})

	const numberOfRequisitions = filteredAppointmentRequisitions?.length
	const requisitionsInProcess = requisitionsExistsInProcessRequisitions(
		filteredAppointmentRequisitions,
		processRequisitions
	)

	const alertMessage = numberOfRequisitions
		? {
				title: i18n`Warning`,
				content: (
					<small>
						{numberOfRequisitions > 1
							? i18n`Cancelling this appointment ${numberOfRequisitions} requisitions will be canceled.`
							: i18n`Cancelling this appointment ${numberOfRequisitions} requisition will be canceled.`}

						{numberOfRequisitions
							? renderRequisitionsLinks(
									requisitionsInProcess,
									gotoRequisition,
									data.processId
							  )
							: null}
					</small>
				),
		  }
		: null

	const infoItems = [
		{
			title: i18n`Service provider`,
			text: appointment?.establishment?.name || '-',
			icon: 'location-alt',
		},
		{
			title: i18n`Appointment date`,
			text: appointment?.date?.dateTimeFormat || '-',
			icon: 'calendar',
		},
		{
			title: i18n`Specialty`,
			text: appointment?.medicalSpecialty?.name || '-',
			icon: 'leading',
		},
		{
			title: i18n`Transport`,
			text: appointment?.transport || '-',
			icon: 'transport',
		},
		{
			title: i18n`Appointment doctor`,
			text: appointment?.doctor?.name || '-',
			icon: 'medical-info',
		},
		{
			title: i18n`State`,
			text: appointment?.status?.description || '-',
			icon: 'info',
		},
	]

	const reason = {
		title: i18n`Nullify reason`,
		text: data.processRequest?.reason,
	}

	const dataToHeader = {
		processId: data.processId,
		appointment: {
			id: data.processRequest?.appointmentId,
			medicalSpecialty: appointment?.medicalSpecialty,
		},
		requisitionDate: { shortDateFormat: data.createdAt },
	}

	return (
		<GenericCancelController
			data={{
				task: data,
				infoItems,
				alertMessage,
				reason,
			}}
			requisition={dataToHeader}
			dismiss={dismiss}
			id={id}
		/>
	)
}

export default CancelAppointmentController
